import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { AccountService } from "./account.service";
import { Observable } from "rxjs";
import { Account } from "../user/account.model";
import { finalize } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class AccountGuard implements CanActivate, CanLoad {
  constructor(private accountService: AccountService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.comprobarSiLaSesionNoEsAnonima();
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.comprobarSiLaSesionNoEsAnonima();
  }

  private comprobarSiLaSesionNoEsAnonima(): boolean | Observable<boolean> {
    let result: boolean = false;
    if (
      !!this.accountService.getToken() &&
      this.accountService.getToken() !== "" &&
      !this.accountService.isAuthenticated()
    ) {
      return new Observable<boolean>((subscriber) => {
        this.accountService
          .identity(true)
          .pipe(
            finalize(() => {
              subscriber.complete();
            })
          )
          .subscribe((account) => {
            result = !this.isAnonymous(account);
            subscriber.next(result);
          });
      });
    } else {
      result = !this.accountService.isAnonymous();
    }

    if (!result) {
      this.router.navigate([""]);
    }

    return result;
  }

  private isAuthenticated(account: Account): boolean {
    return !!account && account !== null;
  }

  private isAnonymous(account: Account): boolean {
    if (this.isAuthenticated(account)) {
      if (!!account.authType) {
        return account.authType === null || account.authType === "ANONIMO";
      }
    }

    return true;
  }
}
